import React, { useState } from "react";
import "./SearchFlight.css";
import { Link } from "react-router-dom";
import { AIRPORT_CODES } from "../../Booking/Info";

const SearchFlight = ({ cName, heroImg, title, text }) => {
    const airportEntries = Object.entries(AIRPORT_CODES);
    const [selectedOriginCode, setSelectedOriginCode] = useState(airportEntries[0][0]);
    const [selectedDestinationCode, setSelectedDestinationCode] = useState(airportEntries[1][0]);
    const [selectedDate, setSelectedDate] = useState("");
    const [numPassengers, setNumPassengers] = useState(1);
    const moment = require("moment");

    const handleOriginChange = (e) => {
        setSelectedOriginCode(e.target.value);
    };

    const handleDestinationChange = (e) => {
        setSelectedDestinationCode(e.target.value);
    };

    const handlePassengerChange = (e) => {
        const passengers = parseInt(e.target.value);
        setNumPassengers(passengers);
    };

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };

    const formatDateToDDMMYYYY = (dateStr) => {
        if (!dateStr) return "";
        return moment(dateStr, "YYYY-MM-DD").format("DD/MM/YYYY");
    };

  return (
      <div className={cName}>
        <img alt="Heroimg" src={heroImg} />
        <div className="hero-text">
          <h1>{title}</h1>
          <p>{text}</p>
            <div className="search-form">
                <select
                    className="search-select isEnabled"
                    onChange={handleOriginChange}
                    value={selectedOriginCode}
                >
                    {airportEntries
                        .filter(([code]) => code !== selectedDestinationCode)
                        .map(([code, airport]) => (
                            <option key={code} value={code}>
                                {airport.city} ({code})
                            </option>
                        ))}
                </select>
                <select
                    className="search-select isEnabled"
                    onChange={handleDestinationChange}
                    value={selectedDestinationCode}
                >
                    {airportEntries
                        .filter(([code]) => code !== selectedOriginCode)
                        .map(([code, airport]) => (
                            <option key={code} value={code}>
                                {airport.city} ({code})
                            </option>
                        ))}
                </select>
                <input type="date"
                       placeholder="YYYY-MM-DD"
                       value={selectedDate}
                       onChange={handleDateChange}
                       className="search-input isEnabled"
                />
                <input
                    className="search-input isEnabled"
                    type="number"
                    placeholder="Passengers"
                    value={numPassengers}
                    onChange={handlePassengerChange}
                />
                <Link
                    className="show isEnabled link-unstyled"
                    to={`/booking/${selectedOriginCode}/${selectedDestinationCode}?passengers=${numPassengers}&date=${formatDateToDDMMYYYY(selectedDate)}`}
                    onClick={(e) => {
                        if (!selectedDate) {
                            e.preventDefault();
                            alert("Please select a date before searching.");
                        }
                    }}
                >
                    Search
                </Link>
            </div>
        </div>
      </div>
  );
};

export default SearchFlight;